export default __webpack_public_path__ + "static/media/tusk_of_monoceros_caeli.b73de0c8.png";